/**
 * Get the user's name from localStorage
 * @returns The user's name or null if not found
 */
export const getUserName = (): string | null => {
  return localStorage.getItem('userName');
};

export const isUserSigned = (): boolean => {
  return localStorage.getItem('token') ? true : false;
};
